import { useTranslation } from 'react-i18next'
import type { Lens } from '../hooks/useGraph'

/** Toggles the navigator lens: logical (C4) ⇄ deployment (where it runs). */
export function LensSwitch({ lens, onChange }: { lens: Lens; onChange: (lens: Lens) => void }) {
  const { t } = useTranslation()
  const tab = (value: Lens, label: string) => (
    <button
      type="button"
      role="tab"
      aria-selected={lens === value}
      onClick={() => onChange(value)}
      className={`rounded px-3 py-1.5 text-sm ${
        lens === value ? 'bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900' : 'text-neutral-600 dark:text-neutral-300'
      }`}
    >
      {label}
    </button>
  )
  return (
    <div role="tablist" className="inline-flex rounded border border-neutral-300 p-0.5 dark:border-neutral-700">
      {tab('logical', t('lens.logical'))}
      {tab('deployment', t('lens.deployment'))}
    </div>
  )
}
